import React from 'react';
import Modal from "react-bootstrap/Modal";
import { useTranslation } from "react-i18next";
const SuccessModal = (props) => 
{
    const { t } = useTranslation(); 
    return (
        <>
        {props?.deleteOptionModal ? 
            <Modal show={props?.showPopUp} onHide={props?.confirmDeleteDenied} animation={false} aria-labelledby="Alert" centered className="facet-maxfilter-modal">
                <Modal.Header closeButton>
                <Modal.Title>
                    <div className="filters-alert">
                    <img src={props?.img} alt="Maximum 10 Filters" className="warning-icon" />{t("manageUsers.User_Delete")}
                    </div>
                </Modal.Title>
                </Modal.Header>
                <Modal.Body className="mx-2">
                <div className="row mx-0">
                    <p>{t("manageUsers.Confirmation_Message")}</p>
                </div>
                <div className='cta-btns mt-3 text-end'>
                    <div className="button button-outline" onClick={props?.deleteUser}>{t("manageUsers.Yes")}</div>
                    <div className="button button-primary" onClick={props?.confirmDeleteDenied}>{t("manageUsers.No")}</div>
                </div>
                </Modal.Body>
            </Modal>
                :

            <Modal
            show={props?.showPopUp}
            onHide={props?.closeWarning}
            animation={false}
            aria-labelledby={props?.ariaLabel}
            centered
            className="adduser-modal"
        >
            <Modal.Header closeButton>
            <Modal.Title>
                <div className="filters-alert">{t("manageUsers.Glove_Selector")}</div>
            </Modal.Title>
            </Modal.Header>
            <Modal.Body className="mx-2">
            <div className="row mx-0">
                <div className={props?.alertdangerFlag ? 'alert alert-danger' : props?.alertFlag ? 'alert alert-warning' : 'alert alert-success'} role="alert">
                    {props?.showMessage}
                </div>
            </div>
            </Modal.Body>
        </Modal>
}
</>
    );
};
export default SuccessModal;